import Box from "@mui/material/Box";
import { DataGrid, 
  GridPaginationModel, 
  GridSortModel,
} from "@mui/x-data-grid";
import { useState } from "react";
import CustomToolbar from "../CustomToolBar";
export const SettingGrid = ({
  data,
  column,
  sortByField = "",
  sortByOrder = null,
  rowSelectionOnClick = true,
  rowHeightGetter = null,
  columnVisibility = {},
  handleDoubleClick = undefined,
  editMode = undefined,
  rowModesModel = undefined,
  handleRowModesModelChange = undefined,
  rowEditStopHandler = undefined,
  gridToolbar = undefined,
  processRowUpdate= undefined,
  apiRef = undefined,
  onSortModelChange = undefined,
  gridSortModel = undefined,
  onPaginationModelChange = undefined,
  gridPaginationModel = undefined,
  handleProcessRowUpdateError = undefined,
}) => {
  const [sortModel, setSortModel] = useState<GridSortModel>([
    {
      field: sortByField,
      sort: sortByOrder,
    },
  ]);

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 25,
  });

  return (
    <Box className="setting-grid-box">
      <DataGrid
        rows={data}
        columns={column}
        slots={{ toolbar: gridToolbar || CustomToolbar }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
          filter: {
            filterModel: {
              items: [],
              quickFilterExcludeHiddenColumns: true
            }
          },
          columns: {
            columnVisibilityModel: {
              id: false,
              ...columnVisibility
            }
          }
        }}
        autoHeight={false}
        pageSizeOptions={[25, 50, 100]}
        sortingOrder={["asc", "desc"]}
        sortModel={gridSortModel || sortModel}
        onSortModelChange={(sort) => onSortModelChange ? onSortModelChange(sort) : setSortModel(sort)}
        disableRowSelectionOnClick={rowSelectionOnClick}
        getRowHeight={ rowHeightGetter || undefined  }
        columnVisibilityModel={{
          id: false,
          ...columnVisibility
        }}
        disableColumnMenu
        onCellDoubleClick={handleDoubleClick || undefined}
        editMode={editMode || undefined}
        rowModesModel={rowModesModel || undefined}
        onRowModesModelChange={handleRowModesModelChange || undefined}
        onProcessRowUpdateError={handleProcessRowUpdateError || undefined}
        onRowEditStop={rowEditStopHandler || undefined}
        processRowUpdate={processRowUpdate || undefined}
        apiRef={apiRef || undefined}
        paginationModel={gridPaginationModel || paginationModel}
        onPaginationModelChange={(paginationModel) => onPaginationModelChange ? onPaginationModelChange(paginationModel) : setPaginationModel(paginationModel)}
      />
    </Box>
  );
};
